import React from 'react';
import PropTypes from 'prop-types';
import ParagraphsInputContainer from '../inputs/ParagraphsInputContainer';

const UnscrambleTextItemForm = props => (
  <ParagraphsInputContainer
    values={props.values}
    onChange={props.onChange}
    errors={props.errors}
    disabled={props.disabled}
    submitting={props.submitting}
  />
);

UnscrambleTextItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

UnscrambleTextItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  disabled: false,
};

export default UnscrambleTextItemForm;
